import { Component, OnInit, Input, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, RouterLinkActive, RouterLink } from '@angular/router';
import { NgForm, FormsModule } from '@angular/forms';
import { LlmPlaygroundProjectsService } from '../../../core/services/llm-playground-projects.service';
import { Project, CollaboratorPermission } from '../../../core/models/llm-playground.model';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-llm-playground-projects',
    templateUrl: './llm-playground-projects.component.html',
    imports: [RouterLinkActive, RouterLink, FormsModule, DatePipe]
})
export class LlmPlaygroundProjectsComponent implements OnInit {
  private titleService = inject(Title);
  private route = inject(ActivatedRoute);
  router = inject(Router);
  private llmPlaygroundProjectsService = inject(LlmPlaygroundProjectsService);

  @Input() project: Project = new Project('', [], []);

  createTabPath: string;
  indexTabPath: string;
  projects: Project[] = [];
  loadingProjects = false;

  ngOnInit(): void {
    const pathMatch = this.router.url.match(/(.+)(\/new)$/);
    this.titleService.setTitle("LLM Playground");

    if (pathMatch) {
      this.createTabPath = this.router.url;
      this.indexTabPath = pathMatch[1];
    } else {
      this.loadingProjects = true;
      this.loadProjects();
      this.createTabPath = `${this.router.url}/new`;
      this.indexTabPath = this.router.url;
    }
  }

  getCollaboratorsFullNameList(permissions: CollaboratorPermission[]): string {
    if (permissions && permissions.length) {
      return permissions.map(permission => permission.userName).join(", ");
    }
    return '-';
  }

  onSubmit(form: NgForm) {
    return this.llmPlaygroundProjectsService.create(this.project.name).subscribe(
      project => {
        this.router.navigate(['../', project.id], { relativeTo: this.route });
      },
      errorResponse => {
        form.form.setErrors(errorResponse.error);
      }
    );
  }

  private loadProjects() {
    this.llmPlaygroundProjectsService.getList().subscribe(result => {
      this.projects = result;
      this.loadingProjects = false;
    });
  }
}
